<template>
  <div id="app" class="h-full">
    <Loader></Loader>
    <router-view />
  </div>
</template>

<script>
import Loader from '@/components/Loader'
export default {
  components: {
    Loader
  },
  computed: {
    loading () {
      return this.state.loader
    }
  },
  beforeCreate () {
  },
  created () {

  }
}
</script>

<style lang="scss">
</style>
